import { defaultCellStyle, defaultWrapperStyle } from "./DataGridColumns";
import resources from "../../core/Localization/Localization";
import { dangerColor, warningColor } from "../../assets/jss/material-dashboard-react";
import { partRequestsStateOptions } from "../../utils/mapRequestStates";
import { acceptedStates, activeStates, getRequestStatusByStatusArray, notAcceptedStates } from "../../utils/getRequestStatus";
import { getDateString } from "../../utils/getDateString";

const stateWrapperStyle = {
    ...defaultWrapperStyle,
    minWidth: "50px",
};

const offerWrapperStyle = {
    ...defaultWrapperStyle,
    minWidth: "20px",
};

const warningWrapperStyle = {
    ...offerWrapperStyle,
    opacity: 0.8,
    backgroundColor: warningColor[0],
};

const dangerWrapperStyle = {
    ...offerWrapperStyle,
    opacity: 0.8,
    backgroundColor: dangerColor[0],
};

const offerCellStyle = {
    ...defaultCellStyle,
    textAlign: "center",
    fontWeight: "bold",
    color: "white",
};

export const partrequestColumns = () => [
    {
        field: "id",
        headerName: "ID",
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "title",
        headerName: resources.partRequests.datagrid.title,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    //TODO {
    //     field: "partstate",
    //     headerName: resources.partRequests.datagrid.partstate,
    //     options: {
    //         filter: true,
    //         sort: true,
    //         filterType: "textField",
    //         customBodyRender: defaultCustomBodyRender,
    //     },
    // },
    {
        field: "make",
        headerName: resources.partRequests.datagrid.make,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "model",
        headerName: resources.partRequests.datagrid.model,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "username",
        headerName: resources.partRequests.datagrid.username,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "state",
        headerName: resources.partRequests.datagrid.state,
        filter: true,
        sort: true,
        filterType: "dropdown",
        filterOptions: {
            names: partRequestsStateOptions().map((x) => x.value),
            renderValue: (v) => partRequestsStateOptions().find((x) => x.value === v).headerName,
        },
        customFilterListOptions: {
            render: (v) => `${resources.partRequests.datagrid.state}: ${partRequestsStateOptions().find((x) => x.value === v).headerName}`,
        },
        flex: 1
    },
    {
        field: "states",
        headerName: resources.partRequests.datagrid.states,
        filter: true,
        sort: true,
        filterType: "dropDown",

        filterOptions: {
            names: [`${JSON.stringify(activeStates)}`, `${JSON.stringify(acceptedStates)}`, `${JSON.stringify(notAcceptedStates)}`],
            renderValue: (v) => getRequestStatusByStatusArray(v),
        },
        customFilterListOptions: {
            render: (v) => `${resources.partRequests.datagrid.states}: ${getRequestStatusByStatusArray(v)}`,
        },
        flex: 1
    },
    {
        field: "offers",
        headerName: resources.partRequests.datagrid.offers,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "createdAt",
        headerName: resources.partRequests.datagrid.created,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1,
        valueGetter: (value) => getDateString(value)
    }

    //{ ...timeRangeColumn() },
];
